import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreatePayment from '../CreateForm/CreatePayment';
import UpdatePayment from '../UpdateForm/UpdatePayment';
import { DELETE_IMPORT_PAYMENT_VOUCHER, GET_SUPPLIERS_LIST, LIST_COMMERCIAL_INVOICES, LIST_IMPORT_PAYMENT_VOUCHERS, LIST_PROFORMA_INVOICES } from '../../../services/apiRoutes';
import { useShipmentDetails } from './useShipmentDetails';
import { genericPost } from '../../../services/authServices';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCommanImportShipmentId, getCurrencyList, getPartyLedger, getPaymentToSupplier, getPaymentType } from '../../../services/CommonServices';
import PaymentVoucherView from '../ViewDetails/PaymentVoucherView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import axios from 'axios';

export default function Payment({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const { importShipmentId } = useParams();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Payment');
    const [data, setData] = useState([]);
    const [newShippingId, setNewShippingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [suppliersList, setSuppliersList] = useState([]);

    const [error, setError] = useState(null);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [paymentVoucherId, setPaymentVoucherId] = useState('');
    const [currencyList, setCurrencyList] = useState([]);
    const [paymentToList, setPaymentToList] = useState([]);
    const [partyLedger, setPartyLedger] = useState([]);
    const [paymentType, setPaymentType] = useState([]);
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);


    const navigate = useNavigate();

    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);

    let supplierId, cifFob;

    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.supplierId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getProformaInvoice();
            fetchDataCommercialList();
            getSuppliersList();

            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, paymentVoucherId, deleteAlert, token, modal]);

    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const paymentType = await getPaymentType();
        setPaymentType(paymentType);
        const paymentToList = await getPaymentToSupplier();
        setPaymentToList(paymentToList);
        const partyLedger = await getPartyLedger();
        setPartyLedger(partyLedger);
    }
    const getProformaInvoice = async () => {
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_PROFORMA_INVOICES, payload, {
            });
            if (response.data && response.data.success && response.data.proformaInvoice) {
                const proform = response.data.proformaInvoice.map((invoice) => ({
                    id: invoice.proformaInvoiceId || '',
                    title: invoice.proformaInvoiceNo || '',
                }));
                setProformaInvoiceList(proform);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };
    const fetchDataCommercialList = async () => {
        setLoading(true);
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES, payload);

            if (response.data.success) {
                const commercialInvoices = response.data.data.map((invoice, index) => {
                    return {
                        id: invoice.commercialInvoiceId || '',
                        title: invoice.commercialInvoiceNo || '',
                    };
                });
                setCommercialInvoiceList(commercialInvoices);
            } else {
                setError('No commercial invoices found');
            }
        } catch (error) {
            setError('Error fetching commercial invoices');
            console.error('Error fetching commercial invoices', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: supplierId,
                commanShipmentId: getCommanImportShipmentId,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_IMPORT_PAYMENT_VOUCHERS, payload, {
            });
            if (response.data.success && response.data.paymentVoucher) {
                const { newShippingId } = response.data;
                const paymentVoucherData = response.data.paymentVoucher.map((voucher, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    sn: voucher.paymentVoucherId || '',
                    date: companyDateFormat(voucher?.date) || '',
                    voucherNo: voucher.paymentVoucherNo || '',
                    partyLedger: voucher?.partyLedger?.partyName ?? '',
                    paymentToName: voucher?.paymentToData?.paymentToName ?? '',
                    // supplierName: voucher.clientCompany?.clientCompanyName || '',
                    supplierName: voucher?.partyLedger?.partyName
                        ? voucher.partyLedger.partyName
                        : voucher.clientCompany?.clientCompanyName || '',

                    paymentTypeId: voucher.paymentType?.paymentTypeId || '',
                    baseCurrency: voucher.baseCurrency?.currency || '',
                    currency: voucher.currency?.currency || '',
                    amount1: `${voucher?.currency?.currency_symbol || ''} ${voucher.amount || ''}`,
                    amount2: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.amountInBaseCurrency || ''}`,
                    bankCharges: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.bankCharges || ''}`,
                    conversionRate: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.conversionRate || ''}`,
                    paymentTypeColor: voucher.paymentType?.ColorPlate?.color || '',
                    paymentTypeBgColor: voucher.paymentType?.ColorPlate?.backgroundColor || '',
                }));
                setData(paymentVoucherData);
                setNewShippingId(newShippingId);
            } else {
                setError('No payment vouchers found');
            }
        } catch (error) {
            setError('Error fetching payment vouchers');
            console.error('Error fetching payment vouchers', error);
        } finally {
            setLoading(false);
        }
    };
    const getSuppliersList = async () => {
        try {
            const payload = {
                clientCompanyId: supplierId,

            };

            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });

            if (response.data && response.data.success && response.data.clientCompanies) {
                const suppliersData = response.data.clientCompanies.map((supplier) => ({
                    id: supplier.clientCompanyId,
                    title: supplier.clientCompanyName,
                }));
                setSuppliersList(suppliersData);

            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };


    if (!shipmentDetails) {
        return <p>   <CustomLoader open={shipmentLoading} />
        </p>;
    }
    const handleDelete = async (paymentVoucherId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_IMPORT_PAYMENT_VOUCHER(paymentVoucherId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const PaymentVoucherCardColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center'
            }
        },
        {
            id: 'voucherNo', label: 'Voucher No.', accessor: 'voucherNo', styleAccessor: {
                textAlign: 'center'
            }
        },
        { id: 'supplierName', label: 'Supplier / Party Ledger Name', accessor: 'supplierName' },

        { id: 'paymentToName', label: 'Payment To', accessor: 'paymentToName' },

        { id: 'currency', label: 'currency', accessor: 'currency' },
        {
            id: 'amount1', label: 'Amount', accessor: 'amount1', styleAccessor: {
                textAlign: 'right',
            },
        },
        { id: 'baseCurrency', label: 'Base Currency', accessor: 'baseCurrency' },
        {
            id: 'conversionRate', label: 'conversion Rate', accessor: 'conversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'amount2', label: 'Amount in Base Currency', accessor: 'amount2', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'bankCharges', label: 'Bank Charges', accessor: 'bankCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.sn)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.sn)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.sn)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }
    const handleUpdateClick = (id) => {
        setPaymentVoucherId(id);
        setUpdateModal(true);
    };

    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setPaymentVoucherId('');
    };


    const handleOpenView = (id) => {
        setPaymentVoucherId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setPaymentVoucherId('');
    };

    const handleViewClick = (id) => {
        handleOpenView(id);
    };


    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const clientCompanyId = shipmentDetails.supplierId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.importShipmentId;

    const baseCurrencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;

    const userId = shipmentDetails.userId;
    const companyId = shipmentDetails.companyId;


    return (
        <>
            <div>

                <CustomLoader open={loading} />
                <DetailsPageCard
                    Icon={AccountBalanceOutlinedIcon}
                    columns={PaymentVoucherCardColumns}
                    title={'Payment Voucher'}
                    buttonTitle={'Create Payment Voucher'}
                    handleOpen={handleOpen}
                    data={data}
                    loading={loading}
                    error={error}
                />
                <CustomModal open={modal}  >
                    <CreatePayment
                        fetchData={fetchData}
                        clientCompanyId={clientCompanyId}
                        currencyList={currencyList}
                        paymentType={paymentType}
                        commanShipmentId={getCommanImportShipmentId}
                        setMessage={setMessage}
                        handleClose={handleClose}
                        newShippingId={newShippingId}
                        shipmentId={shipmentId}
                        currencyId={currencyId}
                        currencySymbol={currencySymbol}
                        baseCurrencySymbol={baseCurrencySymbol}
                        baseCurrencyId={baseCurrencyId}
                        shipmentOrgId={shipmentOrgId}
                        proformaInvoiceList={proformaInvoiceList}
                        commercialInvoiceList={commercialInvoiceList}
                        fetchButtonList={fetchButtonList}
                        userId={userId}
                        companyId={companyId}
                        paymentToList={paymentToList}
                        partyLedger={partyLedger}
                        suppliersList={suppliersList}
                    />
                </CustomModal>

                <CustomModal open={updateModal}  >
                    <UpdatePayment
                        fetchData={fetchData}
                        currencyList={currencyList}
                        paymentType={paymentType}
                        setMessage={setMessage}
                        handleClose={handleCloseUpdate}
                        proformaInvoiceList={proformaInvoiceList}
                        paymentVoucherId={paymentVoucherId}
                        commercialInvoiceList={commercialInvoiceList}
                        paymentToList={paymentToList}
                        partyLedger={partyLedger}
                        suppliersList={suppliersList}
                    />
                </CustomModal>
                <CustomModal
                    open={viewModal}
                    modalStyles={{
                        maxHeight: '70vh',
                        top: "10%",
                    }}
                    handleClose={handleCloseView}>
                    <PaymentVoucherView
                        handleClose={handleCloseView}
                        fetchData={fetchData}
                        currencyList={currencyList}
                        paymentType={paymentType}
                        setMessage={setMessage}
                        paymentVoucherId={paymentVoucherId}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
            </div>
        </>
    );
}
